module.exports = __webpack_public_path__ + "img/goldregen-2020-118.4f9d794f.jpg";